<template>
  <div id="Zaplecze">

    <!-- <md-tabs :md-active-tab="0">
      <md-tab id="a" md-label="Lista powiązań">
        <PowiazanieLista/>
      </md-tab>
      <md-tab id="B" md-label='Lista centrali'>
        <CentralaLista/>
      </md-tab>
      <md-tab id="tab-home" md-label="Montaż central" to="/">Montaż Central</md-tab>
    </md-tabs> -->

  </div>
</template>

<script>
import CentralaLista from './CentralaLista'
import PowiazanieCentrali from './PowiazanieCentrali'
import ModulyLista from './ModulyLista'

export default {
  name: 'Zaplecze',
  data () {
    return {
    }
  },
  components: {
    PowiazanieCentrali, CentralaLista, ModulyLista
  }
}
</script>

<style scoped>
div.md-tabs-navigation {
  text-align: center;margin: 0px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Zaplecze.vue